module.exports = __webpack_public_path__ + "static/media/billing3.3b85ff5a.png";